import { useQuery } from 'react-query';

import { FolderTypology, FolderTypologyResponse } from '@/features/easy/preFolderQualification/withoutRORO/types';
import { axios } from '@/lib/axios';

const getFolderAvailableTypologiesAsync = ({ folderId }: { folderId: string }) =>
  axios.get<FolderTypologyResponse>(`/pre-folders/${folderId}/available-typologies`);

export const useGetFolderAvailableTypologiesAsync = ({ folderId }: { folderId: string }) =>
  useQuery<FolderTypology[]>({
    queryKey: ['pre-folders-available-typologies', folderId],
    queryFn: async () => {
      const { data } = await getFolderAvailableTypologiesAsync({ folderId });
      return data?.preFolderTypologyOfFolderResponseList ?? [];
    },
    retry: 3,
  });
